<template>
    <div id="footer" class="container-fluid">
        <div class="logo">
            <img class="logo__img" src="@/assets/img/logo/logo_black.png" alt="logo图">
        </div>
        <p class="title">{{config.name}}</p>
        <div class="address_tel_fax">
            <p>地址：{{config.address}}</p>
            <p>Tel：{{config.tel}}</p>
        </div>
        <p class="email_wx">
            <span>邮箱：{{config.email}}</span>
<!--            <span>公司微信号：{{config.wechat}}</span>-->
        </p>
        <p class="copy">Copyright &copy; 2014 - 2023 <a href="https://beian.miit.gov.cn">闽ICP备2023001565号</a></p>
    </div>
</template>
<script>
    import config from '@/config'

    export default {
        name: "Footer",
        data() {
            return {
                config: config
            };
        }
    };
</script>
<style scoped>
    #footer {
        width: 100%;
        height: 100%;
        color: #fff;
        background: #474747;
        overflow: hidden;
        text-align: center;
    }

    .logo {
        width: 200px;
        height: 100px;
        margin: 20px auto 20px;
    }

    .logo__img {
        width: 100%;
        height: 100%;
    }

    .title {
        font-size: 25px;
        margin-bottom: 20px;
    }

    .address_tel_fax {
        color: #d3d3d3;
        font-size: 14px;
        margin: 10px 0;
    }

    .email_wx {
        color: #d3d3d3;
        font-size: 14px;
    }

    .copy {
        color: #d3d3d3;
        font-size: 14px;
        margin: 20px 0 10px;
    }

    @media screen and (max-width: 997px) {
        .title {
            font-size: 20px;
        }

        .address_tel_fax {
            font-size: 12px;
        }

        .email_wx {

            font-size: 12px;
        }

        .copy {
            font-size: 12px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue